import React, { useState, useEffect } from "react";
import { FaSearch, FaBell, FaBook, FaUserCircle, FaChartLine, FaList, FaCog, FaSignOutAlt, FaUser, FaCogs } from "react-icons/fa";
import Input from '../../components/ui/Input';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import EbraryCourses from '../../components/EbraryCourses';
import UserDashboard from '../../components/UserDashboard';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';

const Dashboard = ({ onSearch, initialQuery }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);


  const [username, setUsername] = useState(null); // Store the username
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [courseIds, setCourseIds] = useState(null); // Store the username
  const [collegeId, setCollegeId] = useState(null); // Store the username
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const navigate = useNavigate();
  const location = useLocation();
  const [collegeDetails, setCollegeDetails] = useState(null);

    // Function to handle the search action
   // Function to handle the search action
   const handleSearch = () => {
    const query = (inputValue || "").trim();
  
    if (!query) {
      alert("Please enter a search term.");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const hasCollege = user && user.collegeId;
  
    const targetPath = hasCollege
      ? `/mylibrary?query=${encodeURIComponent(query)}`
      : `/ebrarycollection?query=${encodeURIComponent(query)}`;
  
    navigate(targetPath, { state: { query } });

  };
  
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUsername(user.username);  // Set username if user is logged in
      setCourseIds(user.courseIds);
      setDisplayname(user.displayname);
      setCollegeId(user.collegeId);
      if (user && user.collegeId) {
        fetch(`https://backend.scholarkart.in/api/colleges/${user.collegeId}`)
          .then((res) => res.json())
          .then((data) => setCollegeDetails(data))
          .catch((err) => console.error('Failed to fetch college details:', err));
      }
    }
  }, []);


  const handleClear = () => {
    setInputValue('');
  };



  return (
    <div className="bg-gray-100 text-gray-900 flex flex-col min-h-full">

    <div className="flex-1 flex flex-col p-1 bg-gradient-to-br from-gray-50 to-gray-200">

        
        <div className="text-center mt-6">
          {collegeDetails ? (
            <>
            <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">

              <div className="relative w-full max-w-lg">

              </div>

              <div className="flex items-center space-x-4 relative">
                <Notification />
                <Profile />
              </div>
            </div>
            
              <h3 className="text-xl font-bold text-blue-800">{collegeDetails.collegeName}</h3>
              <p className="text-sm text-gray-600">{collegeDetails.address}</p>
              <h3 className="text-2xl font-semibold mt-4">Welcome back{displayname ? `, ${displayname}` : ''}!</h3>
              <EbraryCourses collegeId={collegeId} />
            </>
          ) : (
            <>
            <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">
              
              <div className="relative w-full max-w-lg">
              <h3 className="text-2xl font-semibold mt-4">Welcome back{displayname ? `, ${displayname}` : ''}!</h3>
              </div>

              <div className="flex items-center space-x-4 relative">
                <Notification />
                <Profile />
              </div>
            </div>
            
              <UserDashboard />
            </>
          )}
        </div>

        

      </div>

    </div>
  );
};

export default Dashboard;